export default __webpack_public_path__ + "static/media/contactIMG.056ff74c.png";